module.exports = __webpack_public_path__ + "static/img/code.ea5420e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/code.png
// module id = rZie
// module chunks = 1